import { render, staticRenderFns } from "./repeat-config.vue?vue&type=template&id=20537bda&"
import script from "./repeat-config.vue?vue&type=script&lang=js&"
export * from "./repeat-config.vue?vue&type=script&lang=js&"
import style0 from "./repeat-config.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports